import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Lazy load components
const Homepage = lazy(() => import('../HomePage/HomePage'));
const HomePage2 = lazy(() => import('../HomePage2/HomePage2'));
const HomePage3 = lazy(() => import('../HomePage3/HomePage3'));
const HomePage4 = lazy(() => import('../HomePage4/HomePage4'));
const HomePage5 = lazy(() => import('../HomePage5/HomePage5'));
const HomePage6 = lazy(() => import('../HomePage6/HomePage6'));
const AboutUsPage = lazy(() => import('../AboutUsPage/AboutUsPage'));
const ServiceSinglePage = lazy(() => import('../ServiceSinglePage/ServiceSinglePage'));
const PricingPage = lazy(() => import('../PricingPage/PricingPage'));
const CaseStudyPage = lazy(() => import('../CaseStudyPage/CaseStudyPage'));
const PortfolioSingle = lazy(() => import('../PortfolioSingle/PortfolioSingle'));
const CareerPage = lazy(() => import('../CareerPage/CareerPage'));
const CareerSingle = lazy(() => import('../CareerSingle/CareerSingle'));
const TeamPage = lazy(() => import('../TeamPage/TeamPage'));
const TermsPage = lazy(() => import('../TermsPage/TermsPage'));
const PrivacyPage = lazy(() => import('../PrivacyPage/PrivacyPage'));
const BlogPage = lazy(() => import('../BlogPage/BlogPage'));
const BlogDetails = lazy(() => import('../BlogDetails/BlogDetails'));
const ContactPage = lazy(() => import('../ContactPage/ContactPage'));
const NewsPage = lazy(() => import('../NewsPage/NewsPage'));
const TechnologyPartner = lazy(() => import('../TechnologyPartner/TechnologyPartner'));
const M365Landing = lazy(() => import('../../components/service-details-365/page'));
const CyberLanding = lazy(() => import('../../components/service-details-cyber/cybersecurity'));
const MarslabLandingPage = lazy(() => import('../services-deatils-aws/aws'));
const ServiceSection = lazy(() => import('../../components/ServiceSection/ServiceList'));
const TechPartners = lazy(() => import('../../components/technologypartner'));
const CaseStudyDetailPage = lazy(() => import('../CaseStudyPage/Hospitalmanagment'));


const AllRoute = () => {
  return (
    <div className="App">
      <BrowserRouter>
       <Suspense
  fallback={
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#ffffff",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          width: "60px",
          height: "60px",
          border: "6px solid #f3f3f3",
          borderTop: "6px solid #bd021d",
          borderRadius: "50%",
          animation: "spin 1s linear infinite",
        }}
      />
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  }
>
          <Routes>
            <Route path="home-2" element={<Homepage />} />
            <Route path="home" element={<Homepage />} />
            <Route path="/" element={<HomePage2 />} />
            <Route path="home-3" element={<HomePage3 />} />
            <Route path="home-4" element={<HomePage4 />} />
            <Route path="home-5" element={<HomePage5 />} />
            <Route path="home-6" element={<HomePage6 />} />
            <Route path="about" element={<AboutUsPage />} />
            <Route path="service" element={<ServiceSection />} />
            <Route path="service-single/:slug" element={<ServiceSinglePage />} />
            <Route path="pricing" element={<PricingPage />} />
            <Route path="team" element={<TeamPage />} />
            <Route path="casestudy" element={<CaseStudyPage />} />
            <Route path="casestudy-details/:slug" element={<CaseStudyDetailPage />} />
            <Route path="portfolio_details/:slug" element={<PortfolioSingle />} />
            <Route path="career" element={<CareerPage />} />
            <Route path="career-details" element={<CareerSingle />} />
            <Route path="terms-conditions" element={<TermsPage />} />
            <Route path="privacy-policy" element={<PrivacyPage />} />
            <Route path="blog" element={<BlogPage />} />
            <Route path="blog-single/:slug" element={<BlogDetails />} />
            <Route path="news" element={<NewsPage />} />
            <Route path="news-articles" element={<NewsPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="technology-partners" element={<TechnologyPartner />} />
            <Route path="Office-365" element={<M365Landing />} />
            <Route path="Aws-dev" element={<MarslabLandingPage />} />
            <Route path="cyber-security" element={<CyberLanding />} />
          </Routes>
        </Suspense>
        <TechPartners />
      </BrowserRouter>
    </div>
  );
}

export default AllRoute;
